import * as Redux from 'redux'
import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as Router from '../../router'
import * as Constants from './constants'
import * as Filters from './filters'
import * as Types from './types'

const initialState: Types.State = {
  config: null,
  isDirty: false,
  loading: true,
}

interface FieldAction {
  field: Types.UpdateFieldPayload
}

type Action = Request.SuccessAction & FieldAction & IsActive.StateChangeActionObject

const dataReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case Router.ON_ENTER:
    case Request.requestConstant(Constants.FETCH_SOURCE):
    case Request.requestConstant(Constants.UPDATE_SOURCE_SUBMIT):
      return {
        ...state,
        loading: true,
      }
    case Request.successConstant(Constants.FETCH_SOURCE):
      return {
        ...state,
        config: action.payload.response,
        isDirty: false,
        loading: false,
      }
    case IsActive.updateStatusConstant(Constants.UPDATE_SOURCE):
      return {
        ...state,
        config: {
          ...state.config,
          [action.change.key]: action.change.new_value,
        },
        isDirty: true,
      }
    case Constants.UPDATE_SOURCE_FIELD:
      return {
        ...state,
        config: {
          ...state.config,
          [action.field.name]: action.field.value,
        },
        isDirty: true,
      }
    case Request.successConstant(Constants.UPDATE_SOURCE_SUBMIT):
     return {
       ...state,
       isDirty: false,
       loading: false,
     }
    default:
      return state
  }
}

type GenericReducer = (state: any, action: Redux.Action) => any

const modalStateSettingReducer = (sourceReducer: GenericReducer) =>
  (state: {}, action: Redux.Action & Request.SuccessAction) => {
  for (const filterType of Filters.ALL_FILTER_TYPES) {
    for (const sourceType of Filters.ALL_SOURCE_TYPES) {
      if (action.type === Modal.toggleModalConstant(Filters.toggleModalEvent(filterType, sourceType))) {
        return {
          ...state,
          data: Filters.emptyFilterModalState(filterType, sourceType),
        }
      }
    }
  }
  return sourceReducer(state, action)
}

const modalReducerEvent: Modal.ReducerEvent<Filters.AddFilterData> = {
  initializeState: () => Filters.emptyFilterModalState(Filters.TYPE_INCLUDED, Filters.SOURCE_TAG),
  requestEvent: Filters.ADD_FILTERS,
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  modal: modalStateSettingReducer(Modal.reducer(modalReducerEvent)),
})



// WEBPACK FOOTER //
// ./src/pages/source-config/reducer.ts